/*
Copyright @ilogicaly.com 
Includes APIs Endpoint Links

*/

import {webUrl} from "../constants/appInfo"; 
export const apiUrl = `${webUrl}/wp-json/classmock/v1`;
